import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f8f8f6',
    padding: '16px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 24px rgba(0,0,0,0.08)',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
  },
  header: { textAlign: 'center', marginBottom: '32px' },
  logo: { fontSize: '12px', fontWeight: '600', letterSpacing: '0.15em', textTransform: 'uppercase', color: '#888', marginBottom: '8px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#111' },
  fieldWrap: { marginBottom: '18px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#444', marginBottom: '6px' },
  input: {
    width: '100%', padding: '11px 13px',
    border: '1.5px solid #ddd', borderRadius: '8px',
    fontSize: '15px', outline: 'none',
  },
  btn: {
    width: '100%', padding: '13px',
    background: '#111', color: '#fff',
    border: 'none', borderRadius: '8px',
    fontSize: '15px', fontWeight: '600',
    cursor: 'pointer', marginTop: '4px',
  },
  error: { color: '#dc2626', fontSize: '13px', marginBottom: '14px', textAlign: 'center' },
};

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // Ensures browser stores the httpOnly cookie
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed.');
      } else {
        // Token is now in an httpOnly cookie — only store UI state in localStorage
        localStorage.setItem('role', data.role);
        localStorage.setItem('username', data.username);
        navigate('/admin');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <div style={s.logo}>The Real Autograph</div>
          <div style={s.title}>Admin Login</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={s.fieldWrap}>
            <label style={s.label}>Username</label>
            <input
              style={s.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              autoComplete="username"
            />
          </div>
          <div style={s.fieldWrap}>
            <label style={s.label}>Password</label>
            <input
              style={s.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button type="submit" style={s.btn} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
